import { AUTHMANAGE } from '../actionTypes'

const initialState = {
  cityList: [],
  roleList: {},
  roleInfo: {},
  entityList: [],
  allResources: [],
}

export default function response(state = initialState, action: Action) {
  switch (action.type) {
    case AUTHMANAGE.UPDATE_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
